import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { useFields } from "../../../api/queries/enum/useFields";
import {
  TreeTable,
  TreeTableExpandedKeysType,
  TreeTableRowMouseEvent,
} from "primereact/treetable";
import { useEffect, useState } from "react";
import { TreeNode } from "primereact/treenode";
import { Button } from "primereact/button";

export default function FieldList() {
  const navigate = useNavigate();

  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<TreeTableExpandedKeysType>();

  const { data: fieldsResponse, isLoading } = useFields(); // flat

  const onRowClick = ({ node }: TreeTableRowMouseEvent) => {
    navigate(`/admin/fields/${node.data.id}`);
  };

  useEffect(() => {
    if (!fieldsResponse) return;

    const fields = fieldsResponse.data.results;
    const newNodes: TreeNode[] = [];

    const getChildren = (nodeId: string): TreeNode[] => {
      return fields
        .filter((item) => item.parent?.id === nodeId)
        .map((item) => ({
          id: item.id,
          key: item.id,
          label: item.name,
          data: item,
          expanded: true,
          children: getChildren(item.id),
        }));
    };

    fields.forEach((item) => {
      if (item.parent === null) {
        newNodes.push({
          id: item.id,
          key: item.id,
          label: item.name,
          data: item,
          expanded: true,
          children: getChildren(item.id),
        });
      }
    });

    setNodes(newNodes);
  }, [fieldsResponse]);

  useEffect(() => {
    if (!fieldsResponse) return;

    const keys: TreeTableExpandedKeysType = {};

    fieldsResponse.data.results.forEach((item) => {
      keys[item.id] = true;
    });

    setExpandedKeys(keys);
  }, [fieldsResponse]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Fields</h1>

        <Button
          onClick={() => navigate("/admin/fields/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <TreeTable
        emptyMessage={"No records"}
        lazy={false}
        paginator={false}
        loading={isLoading}
        className="p-datatable-sm p-datatable-pointer"
        stripedRows={true}
        value={nodes}
        expandedKeys={expandedKeys} // FIXME
        onRowClick={onRowClick}
      >
        <Column header={"Name"} field={"name"} expander />
        <Column header={"Type"} field={"type"} />
      </TreeTable>
    </div>
  );
}
